import { render, staticRenderFns } from "./conferencePreview.vue?vue&type=template&id=ff241f6e&scoped=true"
import script from "./conferencePreview.vue?vue&type=script&lang=js"
export * from "./conferencePreview.vue?vue&type=script&lang=js"
import style0 from "./conferencePreview.vue?vue&type=style&index=0&id=ff241f6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff241f6e",
  null
  
)

export default component.exports